// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3wi4N","list":"PatternAutocomplete_list__2S2b5"};